import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const updateUser = async ({ id, body }) => {
  const { data } = await axiosInstance.patch(
    `/promethee_admin/users/${id}/`,
    body
  );
  return data;
};

export const useUpdateUser = (options = {}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: updateUser,
    onSuccess: (data, vars) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] });
      options.onSuccess?.(data, vars);
    },
    onError: options.onError,
  });
  return { updateUser: mutation.mutateAsync, ...mutation };
};
